import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4939dcf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "dialog",
  class: "bussy"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, "処理中です。お待ち下さい。", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("dialog", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ButtonIcon, {
          class: "icon",
          icon: "bussy"
        }),
        _hoisted_3
      ])
    ], 512)
  ]))
}